// twitchWebsocket.jsx - Fixed React component naming
import { useEffect, useRef } from "react";
import tmi from "tmi.js";

// Global event emitter for cross-component communication
const eventEmitter = {
  listeners: {},
  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  },
  off(event, callback) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(
        (cb) => cb !== callback,
      );
    }
  },
  emit(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach((callback) => callback(data));
    }
  },
};

export { eventEmitter };

// Fixed: Component name must start with uppercase letter
export function TwitchWebsocket() {
  const clientRef = useRef(null);

  useEffect(() => {
    if (clientRef.current) return;

    const client = new tmi.Client({
      connection: {
        secure: true,
        reconnect: true,
      },
      channels: ["#padrebobo"],
    });

    client.connect().catch((error) => {
      console.error("Failed to connect:", error);
    });

    client.on("message", (channel, tags, message, self) => {
      if (self) return;

      const username = tags["display-name"];
      const twitch_id = parseInt(tags["user-id"]);
      const color = tags.color || "#fff";

      console.log(`Chat message: ${username} (${twitch_id}): ${message}`);

      // Emit message event for nyeremenyjatek to listen
      eventEmitter.emit("twitchMessage", {
        username,
        twitch_id,
        message,
        color,
        timestamp: new Date(),
      });
    });

    client.on("connected", (address, port) => {
      console.log(`Connected to ${address}:${port}`);
    });

    client.on("disconnected", (reason) => {
      console.log(`Disconnected: ${reason}`);
      clientRef.current = null;
    });

    client.on("error", (error) => {
      console.error("Connection error:", error);
    });

    clientRef.current = client;

    return () => {
      if (client) {
        client.disconnect();
      }
      clientRef.current = null;
    };
  }, []);

  return null;
}

// Optional: Export both for backward compatibility
export const twitchWebsocket = TwitchWebsocket;
